import { favoritesActions } from 'affiny-core/modules/favorites/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useDispatchSentFavorites = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!useDispatchSentFavorites.callDone) {
      dispatch(favoritesActions.getSentFavorites(true));
      useDispatchSentFavorites.callDone = true;
    }
  }, []);
};

useDispatchSentFavorites.callDone = false;

export const useDispatchReceivedFavorites = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!useDispatchReceivedFavorites.callDone) {
      dispatch(favoritesActions.getReceivedFavorites(true));
      useDispatchReceivedFavorites.callDone = true;
    }
  }, []);
};

useDispatchReceivedFavorites.callDone = false;
